import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingDocumentApprovalStatusList extends BaseModelAPI {

	static entity = 'outgoingdocumentstatuslist'
	static entityName = 'outgoingdocumentstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
